import ComponentHeadline from "../../utillityComponents/ComponentHeadline";

export default function FaqHome() {
  return (
    <>
    <ComponentHeadline icon="CollectionIcon" pagetitle="FAQ" />
    </>
  )
}